'use strict';

var braintreeGooglePayModel = require('./braintreeGooglePayModel');
var braintreeGeneral = require('../../braintreeGeneral');
var googlePayHelper = require('../helpers/googlePayHelper');

var googlePayErrorMessages = require('../constants/errorMessages');

/**
 * Initialize Braintree Google Pay Model. Pattern Builder is used
 * @returns {Object} Object with booleam "error" flag and "message" attribute with error message
 */
function init() {
    var braintreeGooglePayConfigs = googlePayHelper.getBraintreeGooglePayConfigs();
    var clientToken;
    var btClientInstancePromise;
    var response = {
        error: false,
        message: '',
        btGooglePayModel: null,
        btGooglePayConfigs: null
    };

    if (braintreeGooglePayConfigs) {
        clientToken = braintreeGooglePayConfigs.clientToken;
        btClientInstancePromise = braintreeGeneral.createClientInstance(clientToken);

        braintreeGooglePayModel.init(
            btClientInstancePromise,
            braintreeGooglePayConfigs.isFraudToolsEnabled
        );

        response.btGooglePayModel = braintreeGooglePayModel;
        response.btGooglePayConfigs = braintreeGooglePayConfigs;
    } else {
        response.error = true;
        response.message = googlePayErrorMessages.NO_GOOGLE_PAY_BRAINTREE_CONFIGURATIONS;
    }

    return response;
}

module.exports = {
    init
};
